window.topBannerTextCycler = function () {
	const textEls = document.querySelectorAll(".top-banner__text");
	setInterval(() => {
    const activeEl = [...textEls].find((el) => el.classList.contains("active"));
    activeEl.classList.remove("active");
    if (activeEl.nextElementSibling) {
      activeEl.nextElementSibling.classList.add("active")
    } else {
      textEls[0].classList.add("active");
		};
	}, 5000);
};
